<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
    <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD"
    (RT)="changeMethod()"></app-return-methods>

<div class="contentBox">
    <div class="center col-3">
        <div class="info-logo-container">
            <img [src]="information.logo" class="payment_method_no_interactive __method_brands"
                alt="Logo-peru-methods" />
            <h2>{{ 'deposit-title' | translation | async }}</h2>
        </div>
    </div>
    <div class="col-7">
        <div class="methodInfo">
            <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD"
                (RT)="changeMethod()"></app-return-methods>
            <h1>{{ 'transferTitle' | translation | async }}</h1>
            <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
            <div class="methodForm">
                <h2>{{ 'transferSubtitle' | translation | async }}</h2>
                <app-counter-item [number]="1">
                    <span innerHTML="{{ 'transfer-instructions-step-one' | translation | async }}"></span>
                </app-counter-item>
                <app-counter-item [number]="2">
                    <span innerHTML="{{ 'transfer-instructions-step-two' | translation | async }}"></span>
                </app-counter-item>
                <app-counter-item [number]="3">
                    <span innerHTML="{{ 'transfer-instructions-step-three' | translation | async }}"></span>
                    <app-copy-to-clipboard style="flex: 2"
                        [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
                </app-counter-item>
                <app-counter-item [number]="4">
                    <span innerHTML="{{ stepFourMsg | translation | async }}"> </span>
                    <b><span>LISTO!</span></b>
                </app-counter-item>
                <ng-container *ngIf="merchantHasWallet && bannerRecommedationFF && bannerRecommedationUiFixFF">
                  <div [ngClass]="{'recomendationBannerMobileClass': bannerRecommedationUiFixFF }">
                    <app-recommendations-banner [bannerText]="banerMessage"></app-recommendations-banner>
                  </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="merchantHasWallet && bannerRecommedationFF" >
  <div [ngClass]="{'recomendationBannerClass': bannerRecommedationUiFixFF}">
    <br>
    <app-recommendations-banner [bannerText]="banerMessage"></app-recommendations-banner>
  </div>
</ng-container>
